import { ChangeEvent, forwardRef } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { Search } from '@clds/icon';
import { TextInput, TextInputProps } from '@clds/input';
import { itemLayoutSizeVariant, onelinerSizeVariant, ItemStyleProps } from '@clds/item';
import { messages } from '../../../i18n';

//istanbul ignore next
const StyledSearchBarWrapper = styled.div<Pick<ItemStyleProps, 'size'>>`
  padding: ${(props) => onelinerSizeVariant(props).verticalMargin} ${(props) => itemLayoutSizeVariant(props).horizontalMargin};
`;

export type SearchBarProps = TextInputProps & {
  searchTerm?: string;
  placeholder?: string;
  onChange: (value: string) => void;
  type?: never;
};

export const SearchBar = forwardRef<HTMLInputElement, SearchBarProps>(({ onChange, searchTerm = '', placeholder, ...rest }, ref) => {
  const { formatMessage } = useIntl();

  return (
    <StyledSearchBarWrapper data-test="search-bar" size="sm">
      <TextInput
        inputRef={ref}
        placeholder={placeholder || formatMessage(messages.workspaceMenuSearchBarPlaceholder)}
        trailingDecoration={<Search size="sm" />}
        onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
        value={searchTerm}
        {...rest}
      />
    </StyledSearchBarWrapper>
  );
});
